import React, { useState, useEffect } from 'react'
import VerMediosdePago from './VerMediosdePago.js'
import { MDBInput } from 'mdbreact';
import axios from 'axios'
import { faPlus, faX } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const MediosdePagoAdmin = ({ baseUrl, Titulo }) => {

	//almacena toda la data de mediodePagos 
	const [data, setData] = useState([])
	//almacena el campo Nombre de mediodePago
	const [nombre, setNombre] = useState('')
	//almacena el campo Nombre de mediodePago
	const [estado, setEstado] = useState('')
	//almacena el campo activo de mediodePago
	const [activo, setActivo] = useState(true)
	const [tarifa, setTarifa] = useState(0)
	//almacena la mediodePago seleccionada
	const [mediodePagoSelect, setmediodePagoSelect] = useState({})
	//selecciona la función como eliminar, crear, editar
	const [funcion, setFuncion] = useState('cargando')
	//Alerta del error para la validacion de formulario
	const [alerta, setAlerta] = useState(false)

	//actualiza el registro de la mediodePago seleccionada
	const actualizarDato = (dato, name) => {
		setmediodePagoSelect({ ...mediodePagoSelect, [name]: dato })
	}

	//hace la consulta y trae las mediodePagos y los almacena en data 
	const peticionTraeDatos = () => {
		axios.get(baseUrl)
			.then(response => {
				setData(response.data)
				cambiarVistaPrincipal()
			})
	}

	//realiza petición que borra de la base de datos por medio de la ID
	const peticionDelete = () => {
		let f = new FormData();
		f.append("METHOD", "DELETE");
		axios.post(baseUrl, f, { params: { id: mediodePagoSelect.id } })
			.then(response => {
				setData(data.filter(mediodePago => mediodePago.id !== mediodePagoSelect.id))
				cambiarVistaPrincipal()
			}).catch(error => {
				console.log(error)
			})
	}

	//Selecciona mediodePago para editarla o borrarla 
	const SeleccionarmediodePago = (objeto, funcion) => e => {
		setFuncion(funcion)
		setmediodePagoSelect({
			id: objeto.id,
			activo: objeto.activo === 'true' ? true : false,
			nombre: objeto.nombre,
			estado: objeto.estado,
			tarifa: objeto.tarifa
		})
		if (funcion === 'editar') {
			setFuncion('editar')
		}
	}

	//Consulta para editar campos
	const peticionPut = () => {
		if (mediodePagoSelect.nombre !== '' && mediodePagoSelect.tarifa > -1) {
			let f = new FormData()
			//convierte boleano a cadena
			let cadena = mediodePagoSelect.activo ? 'true' : 'false'
			f.append("activo", cadena)
			f.append("nombre", mediodePagoSelect.nombre)
			f.append("estado", mediodePagoSelect.estado)
			f.append("tarifa", mediodePagoSelect.tarifa)
			f.append("METHOD", "PUT")
			axios.post(baseUrl, f, { params: { id: mediodePagoSelect.id } })
				.then(response => {
					let dataNueva = data
					dataNueva.map(item => {
						if (item.id === mediodePagoSelect.id) {
							item.activo = cadena
							item.nombre = mediodePagoSelect.nombre
							item.estado = mediodePagoSelect.estado
							item.tarifa = mediodePagoSelect.tarifa
						}
					})
					setData(dataNueva)
					cambiarVistaPrincipal()
					setAlerta(false)
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Consulta para subir o crear los datos 
	const peticionPost = () => {
		if (nombre !== '' && estado !== '' && tarifa > -1) {
			let f = new FormData()
			f.append('activo', activo.toString())
			f.append('nombre', nombre)
			f.append('estado', estado)
			f.append('tarifa', tarifa)
			f.append('METHOD', 'POST')
			axios.post(baseUrl, f)
				.then(response => {
					setData(data.concat(response.data));
					setNombre('')
					setEstado('')
					setTarifa(0)
					setActivo(false)
					setAlerta('')
					cambiarVistaPrincipal()
				}).catch(error => {
					console.log(error);
				})
		} else { setAlerta(true) }
	}

	//Trae todas las mediodePagos de la api
	useEffect(() => {
		peticionTraeDatos()
	}, [])

	const cambiarVistaPrincipal = () => {
		setFuncion('ver')
		setAlerta(false)
		setNombre('')
		setEstado('')
		setTarifa(0)
	}

	return (
		<div>
			<div className="row">
				<div className="col-md-6">
					<br />
					<h2>{Titulo}:</h2>
				</div>
				<div className="col-md-6">
					<div className="filtroPedidos">
						{
							{
								'ver': <button
									onClick={e => setFuncion('subir')}
									className="btn boton_estandar btn-lg derecha">
									<FontAwesomeIcon icon={faPlus} />
								</button>,
								'subir': <button
									onClick={e => cambiarVistaPrincipal()}
									className="btn boton_estandar btn-lg derecha">
									<FontAwesomeIcon icon={faX} />
								</button>
							}[funcion]
						}
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-md-12">
					{
						{
							'cargando': <div className="loader">Loading...</div>,
							'ver': <VerMediosdePago
								data={data}
								SeleccionarmediodePago={SeleccionarmediodePago}
							/>,
							'editar':
								<div>
									<h4>Actualizar medio dePago</h4>
									<hr />
									<div className='custom-control custom-switch '>
										<input
											type='checkbox'
											name="activo"
											className='custom-control-input form-control-lg mb-4'
											id='customSwitches'
											checked={mediodePagoSelect.activo}
											onChange={e => actualizarDato(e.target.checked, e.target.name)}
											readOnly
										/>
										<label className='custom-control-label' htmlFor='customSwitches'>
											Activar/Desactivar
										</label>
									</div>
									<MDBInput
										label="Nombre Medio de Pago"
										onChange={e => actualizarDato(e.target.value, e.target.name)}
										name="nombre"
										className={alerta ? "form-control is-invalid" : null}
										value={mediodePagoSelect && mediodePagoSelect.nombre}
										outline />
									<MDBInput
										label="Tarifa Medio de Pago (%)"
										type='number'
										value={mediodePagoSelect && mediodePagoSelect.tarifa}
										onChange={e => actualizarDato(e.target.value, e.target.name)}
										name="tarifa"
										required
										className={alerta ? "form-control is-invalid" : null}
										outline />
									<select className={`browser-default custom-select ${alerta ? "is-invalid" : null}`}
										value={mediodePagoSelect.estado}
										name="estado"
										onChange={e => actualizarDato(e.target.value, e.target.name)}>
										<option>Selecciona Estado</option>
										<option value="contado">Contado</option>
										<option value="credito">Crédito</option>
									</select>
									<div className="col text-center">
										<br />
										<button
											onClick={peticionPut}
											className="btn boton_estandar"
										>Actualizar Medio de Pago
										</button>
										<button
											onClick={e => cambiarVistaPrincipal()}
											className="btn boton_estandar"
										>Cancelar
										</button>
									</div>
								</div>,

							'subir':
								<div>
									<h4>Subir medio de Pago</h4>
									<hr />
									<div className='custom-control custom-switch '>
										<input
											type='checkbox'
											name="activo"
											className='custom-control-input form-control-lg mb-4'
											id='customSwitches'
											checked={activo}
											onChange={e => setActivo(!activo)}
											readOnly
										/>
										<label className='custom-control-label' htmlFor='customSwitches'>
											Activar/Desactivar
										</label>
									</div>
									<MDBInput
										label="Nombre Medio de Pago"
										value={nombre}
										onChange={e => setNombre(e.target.value)}
										name="nombre"
										required
										className={alerta ? "form-control is-invalid" : null}
										outline />
									<MDBInput
										label="Tarifa Medio de Pago (%)"
										type='number'
										value={tarifa}
										onChange={e => setTarifa(e.target.value)}
										name="tarifa"
										required
										className={alerta ? "form-control is-invalid" : null}
										outline />

									<select className={`browser-default custom-select ${alerta ? "is-invalid" : null}`}
										value={estado}
										onChange={e => setEstado(e.target.value)}>
										<option>Selecciona Estado</option>
										<option value="contado">Contado</option>
										<option value="credito">Crédito</option>
									</select>
									<br />
									<div className="col text-center">
										<br />
										<button
											onClick={peticionPost}
											className="btn boton_estandar"
										>Subir Medio de Pago
										</button>

									</div>
								</div>,
							'eliminar': <div>
								<h4>¿Desea Realmente Eliminar?</h4>
								<hr />
								<div className="col text-center">

									<p>medio de Pago: {mediodePagoSelect.nombre}</p>
									<button
										onClick={peticionDelete}
										className="btn boton_estandar"
									>Eliminar
									</button>

								</div>
							</div>

						}[funcion]
					}
				</div>
			</div>
		</div>
	)
}

export default MediosdePagoAdmin
